import React from "react";
import Label from "./Label";
import { inputClassName, inputErrorClassName } from "./classNames";
import ErrorIcon from "../Icons/ErrorIcon";

const TextArea = ({
  id, 
  label="", 
  placeholder="", 
  register,
  errors=false,
}) => {
  return (
    <div>
      <Label htmlFor={id} label={label} />
      <textarea
        id={id}
        rows={4}
        className={inputClassName}
        placeholder={placeholder}
        {...register}
      />
      {errors && errors[id] && (
        <div className="text-red-500 text-sm mt-1 flex items-center">
          <ErrorIcon />
          <span>{errors[id].message}</span>
        </div>
      )}
    </div>
  );
};

export default TextArea;
